import React from "react";
import { graphql, useFragment } from "react-relay";

import { TodoListItemHeader } from "widgets/src/TodoListItem/TodoListItemHeader";

import {
  TodoListItemContainer,
  TodoListItemContainerContent,
} from "widgets/src/TodoListItem/TodoListItemContainer";
import { TodoListItemMainContentDetails } from "widgets/src/TodoListItem/TodoListItemMainContentDetails";
import { TodoListItemPriority } from "widgets/src/TodoListItem/TodoListItemPriority";
import { TodoListItemMainContentText } from "widgets/src/TodoListItem/TodoListItemMainContentText";
import { TodoListItemFooter } from "widgets/src/TodoListItem/TodoListItemFooter/TodoListItemFooter";
import { TVTodoSubListItem_todo$key } from "./__generated__/TVTodoSubListItem_todo.graphql";
import { TodoOverviewListItemMediumStatusAndPrio } from "widgets/src/WidgetTodoOverview/TodoOverviewListItemMediumStatusAndPrio";

export const TVTodoSubListItem = React.memo(TVTodoSubListItemC);
function TVTodoSubListItemC(props: {
  disabled?: boolean;
  isFirst?: boolean;
  isLast?: boolean;

  todo: TVTodoSubListItem_todo$key;
}) {
  const todo = useFragment(
    graphql`
      fragment TVTodoSubListItem_todo on Todo {
        id
        status
        ordinal
        response {
          __typename
        }
        canWrite

        isOrg
        body
        formattedBody
        canChangeStatus
        expireAtDate {
          isoString
        }

        ...TodoListItemMainContentText_todo
        ...TodoListItemPriority_todo
        ...TodoListItemFooter_todo
        ...TodoOverviewListItemMediumStatusAndPrio_Todo
        ...TodoListItemMainContentDetails_todo
        ...TodoListItemHeader_todo
      }
    `,
    props.todo
  );

  return (
    <TodoListItemContainer
      onPress={() => {}}
      disabled={props.disabled}
      isFirst={props.isFirst}
      isLast={props.isLast}
      disableInsideBorder={true}
    >
      <TodoListItemHeader todo={todo} />

      <TodoListItemContainerContent>
        <TodoListItemPriority todo={todo} />
        <TodoOverviewListItemMediumStatusAndPrio todo={todo} />
        <TodoListItemMainContentText todo={todo} />
        <TodoListItemMainContentDetails todo={todo} />
      </TodoListItemContainerContent>
      <TodoListItemFooter
        todo={todo}
        sizeClass={"regular"}
        currentEmployeeId={undefined}
      />
    </TodoListItemContainer>
  );
}
